var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5 mb-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('iframe',{style:({ height: _vm.iframeHeight  }),attrs:{"width":"100%","src":_vm.iframeSrc,"frameborder":"0","scrolling":"no"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }